import React from 'react';

// Catches the React 18 "removeChild: not a child of this node" crash so we
// see WHICH subtree blew up (componentStack) instead of just a minified
// react-dom.production trace. Renders a debug screen with the error,
// componentStack, and the last actions captured by the debug middleware.
class ErrorBoundary extends React.Component {
    state = { error: null, info: null };

    static getDerivedStateFromError(error) {
        return { error, info: null };
    }

    componentDidCatch(error, info) {
        const dump = {
            time: new Date().toISOString(),
            message: error?.message,
            stack: error?.stack,
            componentStack: info?.componentStack,
            recentActions: (typeof window !== 'undefined' && window.__okoylDebug?.actions) || [],
        };
        this.setState({ info: dump });
        try {
            localStorage.setItem('okoyl_last_crash', JSON.stringify(dump));
        } catch (_) {}
        // Keep the error in console too so the user's existing devtools
        // session sees it without the 200-line minified react-dom frame.
        // eslint-disable-next-line no-console
        console.error('[Okoyl crash]', dump);
    }

    render() {
        if (!this.state.error) return this.props.children;
        const { error, info } = this.state;
        return (
            <div style={{
                position: 'fixed', inset: 0, zIndex: 9999,
                background: '#0c0a12', color: '#e8e3d4',
                fontFamily: 'monospace', fontSize: 12,
                padding: 24, overflow: 'auto',
            }}>
                <h2 style={{ color: '#c0392b', fontFamily: 'serif', fontSize: 22 }}>
                    Okoyl — crash capturé
                </h2>
                <p style={{ color: '#aaa' }}>{error?.message || String(error)}</p>
                <details open style={{ marginTop: 16 }}>
                    <summary style={{ cursor: 'pointer', color: '#c8902a' }}>componentStack</summary>
                    <pre style={{ whiteSpace: 'pre-wrap', color: '#9a6cec' }}>{info?.componentStack || '(not available)'}</pre>
                </details>
                <details style={{ marginTop: 12 }}>
                    <summary style={{ cursor: 'pointer', color: '#c8902a' }}>error.stack</summary>
                    <pre style={{ whiteSpace: 'pre-wrap' }}>{error?.stack || '(no stack)'}</pre>
                </details>
                <details style={{ marginTop: 12 }} open>
                    <summary style={{ cursor: 'pointer', color: '#c8902a' }}>
                        Dernieres actions Redux ({info?.recentActions?.length || 0})
                    </summary>
                    <pre style={{ whiteSpace: 'pre-wrap', color: '#86c66f' }}>
                        {(info?.recentActions || []).map((a, i) =>
                            `${i.toString().padStart(2,'0')}  ${a.t}  ${a.type}`
                        ).join('\n')}
                    </pre>
                </details>
                <p style={{ marginTop: 16, color: '#666' }}>
                    Copie tout (clic droit → "Copy element") et envoie-le.
                    Le dump est aussi dans <code>localStorage.okoyl_last_crash</code>.
                </p>
            </div>
        );
    }
}

export default ErrorBoundary;
